import React from "react";
import { useParams } from "react-router-dom";
import NavBar from "../components/NavBar";
import ServiceDetail from "../components/ServiceDetail";
import Footer from "../components/Footer";
import ReactGA from "react-ga";

ReactGA.pageview(window.location.pathname + window.location.search);

// const url = "http://localhost:3001/uploads/frontendpics/";
const url = "https://res.cloudinary.com/duchitv8b/image/upload/w_auto,q_auto,f_auto/c_limit,w_1500/"
const serviceData = {
  "art-studio-rental": {
    imgSrc: `${url}zwe1277rnhjebnkwwgqo.webp`,
    imgAlt: "Art Studio",
    title: "Art Studio Rental",
    price: "500",
    imagee: `${url}zwe1277rnhjebnkwwgqo.webp`,
    description:
      "Our studio is a fully equipped workspace designed to inspire your artistic journey. It offers ample natural light and all the necessary tools to bring your vision to life. With our convenient lighting options, you can work day or night, ensuring your creative process isn't hindered by time constraints.",
    gallery: [
      `${url}uuhiafpy34c6jltpys6l.webp`,
      `${url}pdurqhv6vppnf7pb7ldq.webp`,
      `${url}fr3fji9ahejo7ps11gqr.webp`,
      `${url}jukddn01eruhnfykiv0t.webp`,
    ],
  },
  "workshops-and-classes": {
    imgSrc: `${url}h0uoxwo0eufsdbuluftf.webp`,
    imgAlt: "Workshops",
    title: "Workshops and Classes",
    price: "400",
    description:
      "Learn from experienced wildlife artists and hone your skills through our engaging art classes. Our curriculum covers a variety of techniques, from sketching and painting to digital art. Whether you're a beginner or an advanced artist, we have a class tailored to your level.",
    imagee: `${url}wdulfr0t8rrqzjqginmv.webp`,
    gallery: [
      `${url}o1fcy4ihtd5sxe6yf7r0.webp`,
      `${url}bmqj5vcska9n5iwmsfhq.webp`,
      `${url}dll0bbajtu0pctwxsjhe.webp`,
      `${url}sqxjudil8bfiiutoquen.webp`,
    ],
  },
  "framing-and-restoration": {
    imgSrc: `${url}x4gstfwf1bnca6r0nzcb.webp`,
    imgAlt: "Framing and Restoration",
    title: "Framing and Restoration",
    price: "450",
    description:
      "Protect your precious artwork with our professional framing and restoration services services. Our skilled artisans will carefully select the perfect frame to complement your piece and ensure its long-lasting beauty.",
    imagee: `${url}c7wp5sxjojyfewkemikk.webp`,
    gallery: [
      `${url}rqwcx4fcwajhlfdywmze.webp`,
      `${url}i1w970ei5ifclaycta5u.webp`,
      `${url}u5j3v1kw4x0mvqtsiwcq.webp`,
      `${url}strbcmnp2fnqbfuhow84.webp`,
    ],
  },
  commissions: {
    imgSrc: `${url}o7dcbihdurtltxetdegl.webp`,
    imgAlt: "Commissions",
    title: "Commissions",
    price: "100",
    description: "Commission custom artwork tailored to your preferences.",
    gallery: [
      "/images/commission1.png",
      "/images/commission2.png",
      "/images/commission3.png",
      "/images/commission4.png",
    ],
  },
};

const ServiceDetails = () => {
  const { serviceId } = useParams();
  const service = serviceData[serviceId];

  if (!service) {
    return <div>Service not found</div>;
  }

  return (
    <div>
      <NavBar />
      <ServiceDetail {...service} />
      <Footer />
    </div>
  );
};

export default ServiceDetails;
